import { getApiBaseUrl } from "./apiBaseUrl";

export const createRequestId = () => {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};

const shouldAttachRequestId = (url) => {
  if (!url) return false;
  const apiBaseUrl = getApiBaseUrl();
  return url.startsWith("/api") || url.startsWith(apiBaseUrl);
};

export const installRequestIdFetchInterceptor = () => {
  if (typeof window === "undefined" || typeof window.fetch !== "function")
    return;
  if (window.__questRequestIdInterceptorInstalled) return;

  const originalFetch = window.fetch.bind(window);

  window.fetch = (input, init = {}) => {
    const requestUrl = typeof input === "string" ? input : input?.url;
    if (!shouldAttachRequestId(requestUrl)) {
      return originalFetch(input, init);
    }

    const headers = new Headers(
      init.headers || (typeof input !== "string" ? input.headers : undefined),
    );
    if (!headers.has("x-request-id")) {
      headers.set("x-request-id", createRequestId());
    }

    if (typeof input !== "string") {
      const requestWithHeaders = new Request(input, { headers });
      return originalFetch(requestWithHeaders, init);
    }

    return originalFetch(input, { ...init, headers });
  };

  window.__questRequestIdInterceptorInstalled = true;
};
